// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"317":"css/admin/app","322":"css/platform/platform","336":"css/search/search-form","411":"css/platform/platform_rtl","764":"css/search/search-results"}[chunkId] + ".css";
};